import React from 'react';

import SelectGlobalClassroom from '../containers/SelectGlobalClassroom';
import SelectGlobalDistrict from '../containers/SelectGlobalDistrict';
import SelectGlobalSchool from '../containers/SelectGlobalSchool';

import classnames from 'classnames';

import '../../styles/SelectDistrictSchoolAndClassroom';

class SelectDistrictSchoolAndClassroom extends React.Component {
	render() {
		return (
			<div className="select-district-school-and-classroom row">
				<div className="col-lg-4">
					<SelectGlobalDistrict />
				</div>
				<div className="col-lg-4">
					<SelectGlobalSchool />
				</div>
				<div className="col-lg-4">
					<SelectGlobalClassroom />
				</div>
			</div>
		);
	}
}

SelectDistrictSchoolAndClassroom.displayName = 'SelectDistrictSchoolAndClassroom';

export default SelectDistrictSchoolAndClassroom;



// WEBPACK FOOTER //
// ./frontend/a2i/js/components/SelectDistrictSchoolAndClassroom.jsx